import loadable from '@loadable/component';

export type {
  ProductSliderItem,
  ProductSliderProps,
} from './LoadableProductSlider';

export const ProductSlider = loadable(() => import('./LoadableProductSlider'), {
  ssr: false,
});
